import { render, staticRenderFns } from "./CompareModal.vue?vue&type=template&id=86b8a982&scoped=true"
import script from "./CompareModal.vue?vue&type=script&lang=js"
export * from "./CompareModal.vue?vue&type=script&lang=js"
import style0 from "./CompareModal.vue?vue&type=style&index=0&id=86b8a982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b8a982",
  null
  
)

export default component.exports